<template>
  <div id="listener_carrello_insit">
    <v-card v-if="items_carrello.length == 0">
      <v-toolbar class="white--text" color="indigo" dense>
        <v-row>
          <v-col align="left" cols="4">
            <v-toolbar-title>
              Work Order -
              <b>{{
                cod_turno_sel != null && cod_turno_sel != ""
                  ? cod_turno_sel
                  : "N/D"
              }}</b>
            </v-toolbar-title>
          </v-col>
          <v-col align="center" cols="4">
            <!-- Bottone per la gestione dei pulsanti del cruscotto -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="isAdmin"
                  class="mr-5"
                  @click="clickGestionePulsanti"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary">mdi-cog</v-icon>
                </v-btn>
              </template>
              <span>Gestione Pulsanti</span>
            </v-tooltip>
          </v-col>
          <v-col align="right" cols="4">
            <!-- Bottone per tornare indietro -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="gotoDashboard" v-bind="attrs" v-on="on" small>
                  <v-icon color="error">mdi-keyboard-backspace</v-icon>
                </v-btn>
              </template>
              <span>Vai alla Dashboard</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-toolbar>

      <v-card-text class="mt-5" style="font-size: 20px; line-height: 20px">
        Ciao {{ nome_utente }}, la lista dei Work Order è vuota: ne vuoi
        aggiungere uno?
      </v-card-text>
      <v-divider></v-divider>
      <!-- Bottone per aggiungere una commessa singola -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5 my-2"
            @click="clickAggiungi"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary">mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Aggiungi Work Order</span>
      </v-tooltip>
    </v-card>

    <v-card v-if="items_carrello.length > 0">
      <v-toolbar rounded class="white--text" color="indigo" dense>
        <v-row>
          <v-col align="left" cols="4">
            <v-toolbar-title>
              Work Order - turno:
              <b>{{
                cod_turno_sel != null && cod_turno_sel != ""
                  ? cod_turno_sel
                  : "N/D"
              }}</b>
            </v-toolbar-title>
          </v-col>
          <v-col align="center" cols="4">
            <!-- Bottone per aggiungere le commesse -->
            <span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mr-5"
                    @click="clickAggiungi"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Aggiungi Work Order</span>
              </v-tooltip>
            </span>

            <!-- Bottone per la configurazione dei bottoni del cruscotto -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  @click="clickGestionePulsanti"
                  small
                  v-bind="attrs"
                  v-on="on"
                  v-if="isAdmin"
                >
                  <v-icon color="primary">mdi-cog</v-icon>
                </v-btn>
              </template>
              <span>Gestione WO</span>
            </v-tooltip>
          </v-col>

          <v-col align="right" cols="4">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="gotoDashboard" v-bind="attrs" v-on="on" small>
                  <v-icon color="error">mdi-keyboard-backspace</v-icon>
                </v-btn>
              </template>
              <span>Vai alla Dashboard</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-toolbar>
    </v-card>

    <v-list two-line>
      <template v-for="(item, index) in items_carrello">
        <v-list-item :key="item.id">
          <template v-slot:default>
            <v-list-item-action>
              <v-container>
                <v-row
                  align="center"
                  justify="start"
                  v-for="(row, ridx) in rows"
                  :key="ridx"
                >
                  <v-col
                    cols="4"
                    v-for="(btn, bidx) in row.pulsanti.filter(
                      (b) => b.tipo_oggetto != 'BQ'
                    )"
                    :key="bidx"
                  >
                    <!--pulsante start/stop classico con la finestra di dialogo -->
                    <span v-if="btn.text == 'Start/stop'">
                      <!-- Bottone dello start -->
                      <v-tooltip
                        bottom
                        v-if="
                          item.ora_start == null ||
                          (item.ora_start != null && item.ora_stop != null)
                        "
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            class="button my-1"
                            @click="
                              switchStartStop(
                                item,
                                '',
                                'on',
                                'dialog_on',
                                btn.fields
                              )
                            "
                            :color="'success'"
                            :disabled="
                              (item.view_disegno != 1 &&
                                item.id_disegno != null) ||
                              item.note_fase === true
                            "
                            tile
                            x-large
                          >
                            <v-icon style="font-size: 50px"> mdi-play </v-icon>
                          </v-btn>
                        </template>
                        <span>Start</span>
                      </v-tooltip>

                      <!-- Bottone dello stop -->
                      <v-tooltip bottom v-else>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            class="button my-1"
                            @click="
                              switchStartStop(
                                item,
                                '',
                                'on',
                                'dialog_on',
                                btn.fields
                              )
                            "
                            :color="'error'"
                            :disabled="
                              (item.view_disegno != 1 &&
                                item.id_disegno != null) ||
                              item.note_fase === true
                            "
                            tile
                            x-large
                          >
                            <v-icon style="font-size: 50px"> mdi-stop </v-icon>
                          </v-btn>
                        </template>
                        <span>Stop</span>
                      </v-tooltip>
                    </span>

                    <!--pulsante start/stop senza la finestra di dialogo-->
                    <v-tooltip
                      bottom
                      v-else-if="btn.text == 'Rilevazione Tempi'"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="button my-1"
                          @click="
                            switchStartStop(
                              item,
                              '',
                              'on',
                              'dialog_off',
                              btn.fields
                            )
                          "
                          :color="
                            item.ora_start == null ||
                            (item.ora_start != null && item.ora_stop != null)
                              ? 'success'
                              : 'error'
                          "
                          :disabled="
                            (item.view_disegno != 1 &&
                              item.id_disegno != null) ||
                            item.note_fase === true
                          "
                          tile
                          x-large
                        >
                          <v-icon style="font-size: 50px">
                            {{
                              item.ora_start == null ||
                              (item.ora_start != null && item.ora_stop != null)
                                ? "mdi-play"
                                : "mdi-stop"
                            }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{
                        item.ora_start == null ||
                        (item.ora_start != null && item.ora_stop != null)
                          ? "Start"
                          : "Stop"
                      }}</span>
                    </v-tooltip>

                    <!-- Pulsante della visualizzazione disegni -->
                    <v-tooltip
                      bottom
                      v-else-if="btn.text == 'Visualizzazione Disegni'"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="button my-1"
                          @click="clickVisualizzaDisegno(item, btn.fields)"
                          :color="
                            item.id_disegno == null
                              ? 'grey lighten-5'
                              : item.view_disegno == true
                              ? 'primary'
                              : 'error'
                          "
                          tile
                          x-large
                        >
                          <v-icon
                            :color="
                              item.id_disegno == null ? 'primary' : 'white'
                            "
                            style="font-size: 50px"
                          >
                            {{
                              btn.icona !== null &&
                              btn.icona !== undefined &&
                              btn.icona !== ""
                                ? btn.icona
                                : "mdi-eye"
                            }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{
                        btn.tooltip !== null &&
                        btn.tooltip !== undefined &&
                        btn.tooltip !== ""
                          ? btn.tooltip
                          : "Visualizza Disegno"
                      }}</span>
                    </v-tooltip>

                    <!-- Pulsante delle note fase -->
                    <v-tooltip bottom v-else-if="btn.text == 'Note Fase'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="button my-1"
                          @click="clickNoteFase(item, btn.fields)"
                          :color="
                            item.view_fase == 0 || item.view_fase == null
                              ? 'grey lighten-5'
                              : 'error'
                          "
                          tile
                          x-large
                        >
                          <v-icon
                            :color="
                              item.view_fase == 0 || item.view_fase == null
                                ? 'primary'
                                : 'white'
                            "
                            style="font-size: 50px"
                          >
                            {{
                              btn.icona !== null &&
                              btn.icona !== undefined &&
                              btn.icona !== ""
                                ? btn.icona
                                : "mdi-file-cog-outline"
                            }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{
                        btn.tooltip !== null &&
                        btn.tooltip !== undefined &&
                        btn.tooltip !== ""
                          ? btn.tooltip
                          : "Note Fase"
                      }}</span>
                    </v-tooltip>

                    <!-- Bottone del ciclo Autocontrollo -->
                    <v-tooltip
                      bottom
                      v-else-if="btn.text == 'Controllo Qualità'"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="button my-1"
                          :color="item.controllo_needed != 1 ? '' : 'error'"
                          :disabled="item.controllo_needed != 1"
                          @click="clickControlloQualita(item, btn.fields)"
                          tile
                          x-large
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon
                            :color="
                              item.controllo_needed != 1 ? 'primary' : 'white'
                            "
                            x-large
                          >
                            {{
                              btn.icona !== null &&
                              btn.icona !== undefined &&
                              btn.icona !== ""
                                ? btn.icona
                                : "mdi-file-certificate"
                            }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        {{
                          btn.tooltip !== null &&
                          btn.tooltip !== undefined &&
                          btn.tooltip !== ""
                            ? btn.tooltip
                            : "Controllo Qualità"
                        }}
                      </span>
                    </v-tooltip>

                    <!-- Bottone del ciclo Dichiarazione Componenti -->
                    <v-tooltip bottom v-else-if="btn.text == 'Gestione lotti'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="button my-1"
                          @click="clickPrelievi(item, btn.fields)"
                          tile
                          x-large
                          v-bind="attrs"
                          v-on="on"
                          :disabled="item.materia_prima == 0"
                        >
                          <v-icon
                            :color="
                              item.flag_picking == 1 ? 'success' : 'primary'
                            "
                            x-large
                          >
                            {{
                              btn.icona !== null &&
                              btn.icona !== undefined &&
                              btn.icona !== ""
                                ? btn.icona
                                : "mdi-warehouse"
                            }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        {{
                          btn.tooltip !== null &&
                          btn.tooltip !== undefined &&
                          btn.tooltip !== ""
                            ? btn.tooltip
                            : "Dichiarazione Componente"
                        }}
                      </span>
                    </v-tooltip>

                    <!-- Bottone dello storico Prelievi -->
                    <v-tooltip
                      bottom
                      v-else-if="btn.text == 'Storico Prelievi'"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="button my-1"
                          color="grey lighten-2"
                          :disabled="item.materia_prima == 0"
                          tile
                          @click="clickStoricoPrelievi(item, btn.fields)"
                          x-large
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon :color="btn.colore_icona" x-large>
                            {{
                              btn.icona !== null &&
                              btn.icona !== undefined &&
                              btn.icona !== ""
                                ? btn.icona
                                : "mdi-archive-clock-outline"
                            }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        {{
                          btn.tooltip !== null &&
                          btn.tooltip !== undefined &&
                          btn.tooltip !== ""
                            ? btn.tooltip
                            : "Storico Prelievi"
                        }}
                      </span>
                    </v-tooltip>

                    <!-- Bottone della stampa -->
                    <!-- :disabled="item.tipo_avanzamento > 0" -->
                    <v-tooltip
                      bottom
                      v-else-if="btn.text == 'Registrazione Imballi'"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="button my-1"
                          @click="clickStampaEtichetta(item, btn.fields)"
                          :disabled="item.tipo_avanzamento != 4"
                          tile
                          v-bind="attrs"
                          v-on="on"
                          x-large
                        >
                          <v-icon :color="btn.colore_icona" x-large>
                            {{
                              btn.icona !== null &&
                              btn.icona !== undefined &&
                              btn.icona !== ""
                                ? btn.icona
                                : "mdi-printer-settings"
                            }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span
                        >{{
                          btn.tooltip !== null &&
                          btn.tooltip !== undefined &&
                          btn.tooltip !== ""
                            ? btn.tooltip
                            : "Dichiarazione Imballi"
                        }}
                      </span>
                    </v-tooltip>

                    <!-- Bottone della registrazione packaging -->
                    <v-tooltip
                      bottom
                      v-else-if="btn.text == 'Avanzamento Packaging'"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="button my-1"
                          @click="clickAvanzaContenitore(item, btn.fields)"
                          :color="btn.colore_sfondo"
                          :disabled="item.tipo_avanzamento != 2"
                          tile
                          v-bind="attrs"
                          v-on="on"
                          x-large
                        >
                          <v-icon :color="btn.colore_icona" x-large>
                            {{
                              btn.icona !== null &&
                              btn.icona !== undefined &&
                              btn.icona !== ""
                                ? btn.icona
                                : "mdi-package-variant-closed"
                            }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span
                        >{{
                          btn.tooltip !== null &&
                          btn.tooltip !== undefined &&
                          btn.tooltip !== ""
                            ? btn.tooltip
                            : "Avanzamento Packaging"
                        }}
                      </span>
                    </v-tooltip>

                    <!--pulsante visualizza distinta base-->
                    <v-tooltip
                      bottom
                      v-else-if="btn.text == 'Visualizzazione Distinta Base'"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="button my-1"
                          :color="btn.colore_sfondo"
                          @click="btnClick(btn.text, item, btn.fields)"
                          tile
                          x-large
                          :disabled="item.righe_movimenti > 0"
                        >
                          <v-icon
                            style="font-size: 50px"
                            :color="btn.colore_icona"
                          >
                            {{ btn.icona }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ btn.tooltip }}</span>
                    </v-tooltip>

                    <!--pulsante generico-->
                    <v-tooltip
                      bottom
                      v-else-if="btn.text != 'Avvio Multiplo WO'"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="button my-1"
                          :color="btn.colore_sfondo"
                          @click="
                            btnClick(btn.text, item, btn.fields, btn.query)
                          "
                          tile
                          x-large
                        >
                          <v-icon
                            style="font-size: 50px"
                            :color="btn.colore_icona"
                          >
                            {{ btn.icona }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ btn.tooltip }}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-container>
            </v-list-item-action>

            <!-- Sezione della riga di tabella dedicata ai dati del WO -->
            <v-list-item-content>
              <v-container>
                <v-row justify="center" align="center">
                  <v-col
                    cols="3"
                    v-for="(info, i) in items_info_wo.filter(
                      (e) => e.visible == 1
                    )"
                    :key="i"
                  >
                    <div
                      v-if="
                        info.value == 'ora_stop' || info.value == 'ora_start'
                      "
                    >
                      <div class="label">{{ info.tooltip }}</div>
                      <div>
                        {{
                          item[info.value] == null || item[info.value] == ""
                            ? "N/D"
                            : formattaData(item[info.value])
                        }}
                      </div>
                    </div>

                    <div v-else-if="info.value == 'cod_fase'">
                      <div class="label">
                        {{ info.tooltip }}
                        <v-btn
                          @click="clickHistoryWO(item)"
                          small
                          icon
                          color="primary"
                        >
                          <v-icon>mdi-clipboard-text-clock</v-icon>
                        </v-btn>
                      </div>
                      <div>{{ `${item.cod_fase} - ${item.des_fase}` }}</div>
                    </div>

                    <div v-else>
                      <div class="label">{{ info.tooltip }}</div>
                      <div>
                        {{
                          item[info.value] != null ? item[info.value] : "N/D"
                        }}
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <!-- OLD TEMPLATE -->
                <!-- <v-row style="height: 102px" align="center">
                  <v-col md="3">
                    <div class="label">COMMESSA</div>
                    <div>{{ item.cod_commessa }}</div>
                  </v-col>

                  <v-col md="3">
                    <div class="label">ARTICOLO</div>
                    <div>{{ item.cod_articolo }}</div>
                  </v-col>

                  <v-col md="3">
                    <div class="label">MACCHINA</div>
                    <div>{{ item.cod_macchina }}</div>
                  </v-col>

                  <v-col md="3">
                    <div class="label">START</div>
                    <div>
                      {{
                        item.ora_start != "" &&
                        item.ora_start != null &&
                        item.ora_start != undefined
                          ? formattaData(item.ora_start)
                          : "N/A"
                      }}
                    </div>
                  </v-col>
                </v-row>

                <v-row style="height: 102px" align="center">
                  <v-col md="3">
                    <div class="label">
                      WO
                      <v-btn
                        @click="clickHistoryWO(item)"
                        small
                        icon
                        color="primary"
                      >
                        <v-icon>mdi-clipboard-text-clock</v-icon>
                      </v-btn>
                    </div>
                    <div>{{ `${item.cod_fase} - ${item.des_fase}` }}</div>
                  </v-col>

                  <v-col md="3">
                    <div class="label">UTENTE</div>
                    <div>{{ item.nominativo }}</div>
                  </v-col>

                  <v-col md="3">
                    <div class="label">PEZZI</div>
                    <div>
                      {{ item.pezzi_magazzino ? item.pezzi_magazzino : "N/A" }}
                    </div>
                  </v-col>

                  <v-col md="3">
                    <div class="label">STOP</div>
                    <div>
                      {{
                        item.ora_stop != "" &&
                        item.ora_stop != null &&
                        item.ora_stop != undefined
                          ? formattaData(item.ora_stop)
                          : "N/A"
                      }}
                    </div>
                  </v-col>
                </v-row> -->
              </v-container>
            </v-list-item-content>
          </template>
        </v-list-item>

        <v-divider
          v-if="index < items_carrello.length - 1"
          :key="index"
        ></v-divider>
      </template>
    </v-list>

    <v-snackbar
      content-class="snackbar"
      :color="snackbar_background"
      right
      v-model="snackbar"
      :timeout="3000"
    >
      <v-icon :color="snackbar_icon_color" :size="64">{{
        snackbar_icon
      }}</v-icon>
      <h2 :style="{ color: snackbar_text_color + '!important' }" class="ml-16">
        {{ snackbar_text }}
      </h2>

      <v-btn
        @click="snackbar = false"
        fab
        dark
        text
        small
        style="
          margin-top: -6rem;
          float: right !important;
          margin-right: -1rem !important;
        "
      >
        <v-icon :color="snackbar_icon_color">mdi-window-close</v-icon>
      </v-btn>
    </v-snackbar>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-icon class="ruota" size="100">mdi-cog</v-icon>
      <v-icon class="controruota" size="100">mdi-cogs</v-icon>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!--Dialog Visualizzazione Distinta Base-->
    <v-dialog v-model="dialogDistintaBase" width="80vw">
      <v-card>
        <v-toolbar class="white--text" color="indigo" dense>
          <v-toolbar-title> Distinta Base </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="dialogDistintaBase = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <WODistintaBase
          :idCommessa="distintaItem != null ? distintaItem.id_commessa : -1"
          :key="key_distinta_base"
        >
        </WODistintaBase>
      </v-card>
    </v-dialog>

    <!-- Dialog Prova Tabella Custom -->
    <v-dialog v-model="visualizza_dialog_tabella_custom" width="unset">
      <TabelleCustomList
        @click_indietro="visualizza_dialog_tabella_custom = false"
        :modulo="'AVANZAMENTO'"
        :workorder="workorder_sel"
        :visualizza_dialog_tabella_custom="visualizza_dialog_tabella_custom"
      />
    </v-dialog>

    <v-dialog v-model="placingDialog" width="50vw">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Crea Placing </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="assignUbicazionePlacing" small>
            <v-icon color="primary"> mdi-warehouse </v-icon>
          </v-btn>
          <v-btn
            @click="confirmPlacing"
            small
            class="ml-5"
            :disabled="
              !(
                qntPlacing > 0 &&
                qntPlacing <= placingItem.quantita &&
                ubicazionePlacing.id_magazzino_ubicazione != -1 &&
                !loading
              )
            "
          >
            <v-icon color="success"> mdi-check </v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="mr-5" @click="closePlacing" small>
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>
        <v-progress-linear
          indeterminate
          color="cyan"
          v-if="loading"
          id="progress"
        >
        </v-progress-linear>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-text-field
                label="Disponobile"
                readonly
                v-model="placingItem.quantita"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field label="Quantita" v-model="qntPlacing" type="number">
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                label="Ubicazione"
                v-model="ubicazionePlacing.path"
                readonly
                append-outer-icon="mdi-pencil"
                @click:append-outer="selectPlacingUbicazione"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma prima del salvataggio -->
    <v-dialog v-model="conferma_nascondi" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler nascondere il WO
            <b>{{ workorder_sel.cod_fase }} - {{ workorder_sel.des_fase }}</b>
            della commessa <b>{{ workorder_sel.cod_commessa }}</b
            >?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn class="mr-5" @click="conferma_nascondi = false" small>
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="nascondiWO" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_turni_visible" width="unset" persistent>
      <DichiarazioneTurni
        @click_chiudi="dialog_turni_visible = false"
        @click_save="clickSaveTurno"
      />
    </v-dialog>

    <v-dialog v-model="dialog_storico_prelievi" width="unset">
      <v-toolbar color="indigo" dense>
        <v-toolbar-title class="white--text">
          Storico Prelievi
        </v-toolbar-title>
      </v-toolbar>
      <v-data-table :headers="headers_storico" :items="items_storico_prelievo">
      </v-data-table>
    </v-dialog>

    <v-dialog v-model="partProgramDialog" width="75vw">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Invia Part Program
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="mr-5" @click="sendPartProgram" small>
            <v-icon color="success"> mdi-send </v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="mr-5" @click="partProgramDialog = false" small>
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>
        <v-container>
          <GestioneFasiValori
            :id_macchina="idMacchinaTemp"
            :access="2"
            :id_commessa_dettaglio="id_commessa_dettaglio"
            ref="GestioneFasiValori"
          />
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="StampaEttichetaDialog" width="75vw" persistent>
      <StampaEtichettaVue
        :key="uniqueKey"
        :id_ArticoloTemp="idArticoloTemp"
        :idCommessaDettaglio="id_commessa_dettaglio"
        @click_chiudi="
          StampaEttichetaDialog = false;
          uniqueKey = null;
        "
      />
    </v-dialog>
    <v-dialog v-model="graphDialog" width="80vw">
      <v-toolbar class="white--text" color="indigo" dense>
        <v-toolbar-title>Quick Graph</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="graphDialog = false"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>
      <v-card height="80vh" style="overflow-y: scroll">
        <WindowFrame component="graph" :input_args="graphArgs"> </WindowFrame>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
// import TabellaCustom from "@/components/TABELLA_CUSTOM/TabellaCustom.vue";
import TabelleCustomList from "@/components/TABELLA_CUSTOM/TabelleCustomList.vue";
import DichiarazioneTurni from "@/components/PRODUCTION/ProduzioneInsit/DichiarazioneTurno.vue";
import GestioneFasiValori from "@/components/INDUSTRIA_4.0/Gestione Part Program/GestioneFasiValori.vue";
import StampaEtichettaVue from "./StampaEtichetta.vue";
import WODistintaBase from "@/components/PRODUCTION/ProduzioneInsit/WODistintaBase.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

class Workorder {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "autonoma", default_val: null },
      { nome: "cod_macchina", default_val: "" },
      { nome: "costo_orario", default_val: null },
      { nome: "data_acquisto", default_val: "" },
      { nome: "des_centrocosto", default_val: "" },
      { nome: "des_connessione", default_val: "" },
      { nome: "des_funzione", default_val: "" },
      { nome: "des_macchina", default_val: "" },
      { nome: "des_stato", default_val: "" },
      { nome: "des_reparto", default_val: "" },
      { nome: "fine_garanzia", default_val: "" },
      { nome: "flag_4_0", default_val: null },
      { nome: "id_centrocosto", default_val: null },
      { nome: "id_funzione", default_val: null },
      { nome: "id_macchina", default_val: null },
      { nome: "id_reparto", default_val: null },
      { nome: "id_stato", default_val: null },
      { nome: "id_tipo_get_macchina", default_val: null },
      { nome: "inizio_garanzia", default_val: "" },
      { nome: "macchina_img", default_val: "" },
      { nome: "marca", default_val: "" },
      { nome: "matricola", default_val: "" },
      { nome: "modello", default_val: "" },
      { nome: "multi_commessa", default_val: null },
      { nome: "on_line", default_val: null },
      { nome: "ore_disponibilita", default_val: null },
      { nome: "schedula", default_val: null },
      { nome: "specifiche", default_val: null },
      { nome: "tipo_connessione", default_val: null },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "Carrello2",
  components: {
    SnackbarQV,
    WindowFrame,
    // TabellaCustom,
    TabelleCustomList,
    DichiarazioneTurni,
    StampaEtichettaVue,
    GestioneFasiValori,
    WODistintaBase,
  },
  props: {
    back_as_landing_page: {
      type: Boolean,
      default: true,
    },
    items_carrello: { type: Array, default: () => [] },
    rotta_back: {
      type: String,
      default: "/home/production",
    },
    // In onore di Davide
    handleClickCheck: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      graphArgs: {},
      graphDialog: false,
      cod_turno_sel: "",
      id_articolo_sel: null,
      isAdmin: false,
      nome_utente: localStorage.getItem("nominativo"),
      workorder_sel: new Workorder(),
      distintaItem: null,

      // Modal
      // Variabli for Stampa Modal and Part Program
      ciao1: false,
      partProgramDialog: false,
      StampaEttichetaDialog: false,
      idMacchinaTemp: null,
      idArticoloTemp: null,
      id_commessa_dettaglio: null,
      uniqueKey: null,
      //End Variabli of Stampa Modal

      key_distinta_base: 0,
      dialogDistintaBase: false,
      loading: false,
      ubicazionePlacing: { id_magazzino_ubicazione: -1, path: "Nessuno" },
      qntPlacing: 0,
      placingDialog: false,
      avanzamento_packaging_visible: 0,
      btnRowSize: 3,
      conferma_nascondi: false,
      dialog_stampa: false,
      dialog_turni_visible: false,
      dialog_storico_prelievi: false,
      esecuzione_controllo_visible: 0,
      gestione_lotti_visible: 0,
      gestione_team_enabled: 0,
      nascondi_wo_visible: 0,
      registrazione_visible: 0,
      snackbar: false,
      snackbar_background: "",
      snackbar_icon: "",
      snackbar_icon_color: "",
      snackbar_text: "",
      snackbar_text_color: "",
      start_stop_visible: 0,
      stato: true,
      subentro_visible: 0,
      overlay: false,
      visualizza_dialog_tabella_custom: false,
      visualizza_disegni_visible: 0,
      placingItem: { quantita: 0 },
      CommessaData: null,

      // Array
      items_storico_prelievo: [],
      items_info_wo: [],
      headers_storico: [
        { text: "Cod. Lotto", value: "cod_lotto" },
        { text: "Cod. Articolo", value: "cod_articolo" },
        { text: "Des: Articolo", value: "des_articolo" },
        { text: "Qta Impegno", value: "quantita_impegno" },
        { text: "Qta Prelevata", value: "quantita_prelevato" },
      ],
      rows: [{ pulsanti: [] }],
    };
  },
  methods: {
    clickDistintaBase(item) {
      this.distintaItem = Object.assign({}, item);
      this.key_distinta_base = this.key_distinta_base == 1 ? 0 : 1;
      this.dialogDistintaBase = true;
    },
    sendPartProgram() {
      this.$refs.GestioneFasiValori.getPpJSON();
    },
    async confirmPlacing() {
      var movimento = {
        id_magazzino_movimenti: -1,
        id_articolo: this.placingItem.id_articolo,
        id_ubicazione: this.ubicazionePlacing.id_magazzino_ubicazione,
        id_commessa: this.placingItem.id_commessa,
        quantita: this.qntPlacing,
        cod_articolo: this.placingItem.cod_articolo,
        numero_seriale: -1,
        id_controllo: 0,
      };
      this.loading = true;
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setmovimentimagazzino",
          token: localStorage.user_token,
          movimento: [movimento],
        },
      };
      await this.$store
        .dispatch("api", request)
        .then(async (res) => {
          if (res.status === 200) {
            this.$refs.SnackbarQV.print("success", "Placing Salvato");
            this.loading = false;
          } else {
            this.$refs.SnackbarQV.print("error", "Placing non Salvato");
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          if (err) {
            this.$refs.SnackbarQV.print("error", "Placing non Salvato");
          }
        });
      this.placingDialog = false;
    },
    async assignUbicazionePlacing() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getassignubicazioni",
          token: localStorage.user_token,
          articoli: [
            {
              id_articolo: this.placingItem.id_articolo,
              id_famiglia: -1,
              id_sub_famiglia: -1,
            },
          ],
        },
      };
      await this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          if (
            res.data.result[this.placingItem.id_articolo.toString()].length > 0
          ) {
            this.ubicazionePlacing =
              res.data.result[this.placingItem.id_articolo.toString()][0];
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Nessun ubicazione disponibile"
            );
          }
        }
      });
    },
    async clickStampaEtichetta(item, arg_cod_pulsante) {
      if (item.id_magazzino == 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non c'è alcun magazzino predefinito per questo articolo, impossibile registrare imballi."
        );

        return;
      }

      /* Apro la registrazione imballi e la stampa etichette
       * solo se il WO è in stato di start, se è in  stato di
       * stop o mai avviato invece stampo una snackbar di avviso
       * e non faccio nulla. */
      if (
        (item.ora_start == null && item.ora_stop == null) ||
        (item.ora_start != null && item.ora_stop != null)
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Avviare la lavorazione per dichiarare gli imballi."
        );
        return;
      }

      // Controllo se ci sono questionari per questo pulsante.
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.clickStampaEtichetta(item, arg_cod_pulsante);
        },
      };

      const res = await this.handleClickCheck(
        item,
        arg_cod_pulsante,
        stack_obj
      );

      if (res === "S") {
        return;
      }

      this.$emit("click_registra_imballi", item);
    },
    selectPlacingUbicazione() {
      console.log("test");
    },
    closePlacing() {
      this.placingDialog = false;
    },
    clickPlacing(arg) {
      this.placingDialog = true;
      this.placingItem = arg;
    },
    chkDisponibilita(arg) {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getworkordersutentegenerale",
          token: localStorage.getItem("user_token"),
          cod_commessa: this.filtroEM === "1" ? arg.cod_commessa : "",
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            let utilizzatore_macchina = null;
            res.data.workorders.workorder.forEach((w) => {
              /* Cerco il WO che mi interessa, se lo trovo
               * registro il suo utilizzatore_macchina. */
              if (
                w.id_commessa_dettaglio === arg.id_commessa_dettaglio &&
                arg.disponibile === 0
              ) {
                utilizzatore_macchina = w.utilizzatore_macchina;
              }
            });

            // Ritorno il nome dell'utilizzatore che ho trovato.
            return utilizzatore_macchina;
          } else {
            return "";
          }
        })
        .catch((e) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore tecnico nel controllo dell'impegno Work Order."
          );
          console.error(e);
          return "";
        });
    },
    async clickControlloQualita(arg, arg_cod_pulsante) {
      /* Se controllo_needed non è a 1, stampo una snackbar
       * di avviso per informare l'utente che non serve fare
       * un ciclo di autocontrollo e non faccio nulla. */
      if (arg.controllo_needed !== 1) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Nessun autocontrollo è attualmente richiesto per questo Work Order."
        );
      }

      // Controllo se ci sono questionari per questo pulsante.
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.clickControlloQualita(arg, arg_cod_pulsante);
        },
      };

      const res = await this.handleClickCheck(arg, arg_cod_pulsante, stack_obj);

      if (res === "S") {
        return;
      }

      this.$emit("click_controllo_qualita", arg);
    },
    clickHistoryWO(arg) {
      this.$emit("click_history", arg);
    },
    async clickNoteFase(arg, arg_cod_pulsante) {
      // Controllo se ci sono questionari per questo pulsante.
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.clickNoteFase(arg, arg_cod_pulsante);
        },
      };

      const res = await this.handleClickCheck(arg, arg_cod_pulsante, stack_obj);

      if (res === "S") {
        return;
      }

      this.$emit("click_note_fase", arg);
    },
    clickSaveTurno(arg_cod) {
      this.$refs.SnackbarQV.print(
        "success",
        `Turno ${arg_cod} selezionato con successo`
      );
      this.cod_turno_sel = arg_cod;
      this.dialog_turni_visible = false;
    },
    async clickStoricoPrelievi(item, arg_cod_pulsante) {
      // Controllo se ci sono questionari per questo pulsante.
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.clickStoricoPrelievi(item, arg_cod_pulsante);
        },
      };

      const res = await this.handleClickCheck(
        item,
        arg_cod_pulsante,
        stack_obj
      );

      if (res === "S") {
        return;
      }

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getprelievicommessa",
          token: localStorage.getItem("user_token"),
          id_commessa_dettaglio: item.id_commessa_dettaglio,
          quantita: item.quantita,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        this.items_storico_prelievo = res.data.Prelievi;
      });

      this.dialog_storico_prelievi = true;
    },
    fermaLavorazioneTeam(arg) {
      /* Chiedo le persone che hanno le competenze per lavorare
       * su questa fase; alcune di loro possono avere già uno
       * start / stop. In base ai dati, andrò a comunicare al BE
       * dei nuovi stop sugli operatori debiti. */
      const request_get = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessatempisquadra",
          token: localStorage.user_token,
          id_commessa_dettaglio: arg.id_commessa_dettaglio,
        },
      };

      return this.$store
        .dispatch("api", request_get)
        .then((res) => {
          if (res.status === 200) {
            /* Mi metto da parte solo gli operatori già presenti sul
             * DB che abbiano un'ora di start ma non una di stop. */
            const arr_tmp = new Array();
            res.data.squadra.forEach((e) => {
              if (
                e.id_commessa_tempi_squadra != -1 &&
                e.ora_inizio != null &&
                e.ora_fine == null
              ) {
                e.ora_fine = new moment().format("YYYY-MM-DD HH:mm:ss");
                arr_tmp.push(Object.assign({}, e));
              }
            });

            /* Se arr_tmp era vuoto ritorno true, e fine; se
             * invece era popolato faccio ancora la chiamata di
             * set per modificare le ore di stop degli operatori. */
            if (arr_tmp.length > 0) {
              const request_set = {
                controller: "Magazzino",
                method: "PUT",
                richiesta: {
                  action: "setcommessatempisquadra",
                  token: localStorage.user_token,
                  squadra: arr_tmp,
                },
              };

              return this.$store
                .dispatch("api", request_set)
                .then((res) => {
                  if (res.status === 200) {
                    return true;
                  } else {
                    this.$refs.SnackbarQV.print(
                      "orange",
                      "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );

                    return false;
                  }
                })
                .catch((e) => {
                  console.error(e);
                  this.$refs.SnackbarQV.print(
                    "error",
                    "Errore di comunicazione col server, non è stato possibile caricare i dati."
                  );

                  return false;
                });
            } else {
              // Se arr_tmp era vuoto ritorno true, e fine;
              return true;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    formattaData(arg) {
      const res = `${arg.substr(8, 2)}/${arg.substr(5, 2)}/${arg.substr(
        0,
        4
      )} ${arg.substr(11, 5)}`;
      return res;
    },
    getDichiaraTurno() {
      const request2 = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getprofiliturni",
          token: localStorage.user_token,
        },
      };

      this.$store.dispatch("api", request2).then((res) => {
        if (res.status === 200) {
          this.loading = false;
          if (res.data && res.data.result && res.data.result.turni_profili) {
            for (let i2 = 0; i2 < res.data.result.turni_profili.length; i2++) {
              if (
                parseInt(localStorage.getItem("id_profilo")) ==
                res.data.result.turni_profili[i2].id_profilo
              ) {
                this.showTurnoDialog();
                break;
              }
            }
          }
        }
      });
    },
    showTurnoDialog() {
      this.dialog_turni_visible = true;
    },
    async btnClick(text, item, codice_btn, query = -1) {
      // Controllo che non ci siano questionari a cui rispondere.
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.btnClick(text, item, codice_btn);
        },
      };

      const res = await this.handleClickCheck(item, codice_btn, stack_obj);

      if (res === "S") {
        return;
      }

      // Se non ho questionari a cui rispondere vado avanti con la logica normale.
      if (text == "Allegati Fase") {
        this.$emit("click_allegati_fase", item);
      } else if (text == "Check") {
        this.$emit("click_check", item, codice_btn);
      } else if (text == "Invia Part Program") {
        this.id_commessa_dettaglio = item.id_commessa_dettaglio;
        this.idMacchinaTemp = item.id_macchina;
        this.partProgramDialog = true;
      } else if (text == "Stampa etichetta") {
        this.uniqueKey = 1;
        this.idArticoloTemp = item.id_articolo;
        this.idMacchinaTemp = item.id_macchina;
        this.id_commessa_dettaglio = item.id_commessa_dettaglio;
        this.StampaEttichetaDialog = true;
      } else if (text == "Esecuzione Controllo") {
        console.log("unimplemented");
      } else if (text == "Lavoro Squadra") {
        /* Gestisco il team solo se il WO è in stato di start,
         * se è in stato di stop o mai avviato invece stampo
         * una snackbar di avviso e non faccio nulla. */
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Il team può essere gestito solo quando la lavorazione è attiva."
          );
          return;
        }
        this.$emit("click_lavoro_squadra", item);
      } else if (text == "Note Commessa") {
        this.$emit("click_note_commessa", item);
      } else if (text == "NascondiWO") {
        this.clickNascondi(item);
      } else if (text == "Crea Placing") {
        this.clickPlacing(item);
      } else if (text == "Registrazione Alternativa") {
        /* Registro i pezzi solo se il WO è in stato di start,
         * se è in stato di stop o mai avviato invece stampo
         * una snackbar di avviso e non faccio nulla. */
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "I pezzi prodotti possono essere registrati solo quando la lavorazione è attiva."
          );
        } else {
          this.clickRegistraPezziAlternativi(item);
        }
      } else if (text == "Registrazione Pezzi") {
        /* Registro i pezzi solo se il WO è in stato di start,
         * se è in stato di stop o mai avviato invece stampo
         * una snackbar di avviso e non faccio nulla. */
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "I pezzi prodotti possono essere registrati solo quando la lavorazione è attiva."
          );
        } else {
          this.clickRegistraPezzi(item);
        }
      } else if (text == "Dichiarazione Scarti") {
        /* Registro gli scarti solo se il WO è in stato di start,
         * se è in stato di stop o mai avviato invece stampo
         * una snackbar di avviso e non faccio nulla. */
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Gli scarti possono essere registrati solo quando la lavorazione è attiva."
          );
        } else {
          this.clickRegistraScarti(item);
        }
      } else if (text == "Scheda Packaging") {
        if (item.ora_start == null && item.ora_stop == null) {
          this.$refs.SnackbarQV.print(
            "orange",
            "È necessario almeno un avvio prima di accedere ai dettagli del packaging."
          );
          return;
        }

        this.$emit("click_scheda_packaging", item);
      } else if (text == "Subentro") {
        this.clickSubentro(item);
      } else if (text == "Visualizzazione Disegni") {
        this.clickVisualizzaDisegno(item);
      } else if (text == "Richieste") {
        this.$emit("click_scheda_richieste", item);
      } else if (text == "Visualizzazione Distinta Base") {
        this.clickDistintaBase(item);
      } else if (text == "Apre Graph") {
        this.clickGraph(item, codice_btn, query);
      }
    },
    async clickGraph(item, fields, id_query) {
      console.log(item);
      console.log(fields);

      var queryParams = [];
      for (const [key, value] of Object.entries(item)) {
        if (value != null) {
          queryParams.push({ label: "@" + key, value: value.toString() });
        }
      }

      var graphParams = [];
      if (id_query != null && id_query != -1) {
        const request = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "performquery",
            token: localStorage.user_token,
            id_query: id_query,
            params: queryParams,
            query_string: "",
          },
        };

        await this.$store.dispatch("api", request).then((res) => {
          if (res.status === 200) {
            console.log(res.data);
            for (const [key, value] of Object.entries(res.data.result[0])) {
              if (value != null) {
                graphParams.push({ simbolo: key, valore: value });
              }
            }
          }
        });
      }

      this.graphArgs = null;
      if (fields != null && fields != "" && fields.includes(",")) {
        this.graphArgs = {};
        this.graphArgs.evento_target = "load_dashboard";
        this.graphArgs.payload = {};
        this.graphArgs.payload.version = parseInt(fields.split(",")[1]);
        this.graphArgs.payload.dashboard = parseInt(fields.split(",")[0]);
        this.graphArgs.payload.params = graphParams;
      }
      this.graphDialog = true;
    },
    gotoDashboard() {
      if (this.back_as_landing_page === true) {
        this.$router.push(this.rotta_back);
      } else {
        /* Emetto un evento per scatenare nel padre
         * la gestione dell'evento click indietro. */
        this.$emit("click_indietro");
      }
    },
    clickAggiungi() {
      this.$emit("click_aggiungi");
    },

    async clickAvanzaContenitore(item, arg_cod_pulsante) {
      // Controllo se ci sono questionari per questo pulsante.
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.clickAvanzaContenitore(item, arg_cod_pulsante);
        },
      };

      const res = await this.handleClickCheck(
        item,
        arg_cod_pulsante,
        stack_obj
      );

      if (res === "S") {
        return;
      }

      /* Registro i pezzi solo se il WO è in stato di start,
       * se è in stato di stop o mai avviato invece stampo
       * una snackbar di avviso e non faccio nulla. */
      if (
        (item.ora_start == null && item.ora_stop == null) ||
        (item.ora_start != null && item.ora_stop != null)
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "I contenitori possono essere avanzati solo quando la lavorazione è attiva."
        );
        return;
      }

      if (item.id_magazzino == 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non c'è alcun magazzino predefinito per questo articolo, impossibile avanzare contenitori."
        );

        return;
      }

      this.$emit("click_avanza_contenitore", item);
    },
    clickGestionePulsanti() {
      this.$emit("click_gestione_pulsanti");
    },
    clickNascondi(item) {
      /* Se l'utente non ha mai fatto uno start né uno stop
       * gli chiedo di farlo almeno una volta per nasconderlo. */
      if (
        (item.ora_stop == null || item.ora_stop == "") &&
        (item.ora_start == null || item.ora_start == "")
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Per nascondere il Work Order l'utente deve attivarlo almeno una volta."
        );
        return;
      }

      /* Se l'utente non ha mai fatto uno stop
       * gli chiedo di farlo prima di nasconderlo. */
      if (item.ora_stop == null || item.ora_stop == "") {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il Work Order deve essere fermato prima di essere nascosto."
        );
        return;
      }

      this.workorder_sel = Object.assign({}, item);
      this.conferma_nascondi = true;
    },
    nascondiWO() {
      // Chiudo il dialog di conferma.
      this.conferma_nascondi = false;

      // Se il WO è fermo nascondo l'oggetto...
      if (
        this.workorder_sel.ora_start == null ||
        (this.workorder_sel.ora_start != null &&
          this.workorder_sel.ora_stop != null)
      ) {
        this.$emit("click_nascondi", this.workorder_sel);
      } else {
        /* ... Se invece è attivo prima do uno stop e
         * faccio registrare, poi lo nasconderò. */
        this.switchStartStop(this.workorder_sel, "nascondi", "on", "dialog_on");
      }
    },
    async clickPrelievi(item, arg_cod_pulsante) {
      /* Se ora start e ora stop hanno dei valori nulli
       * vuol dire che non ho mai avviato il WO */
      if (item.ora_start == null || item.ora_start == "") {
        this.$refs.SnackbarQV.print(
          "orange",
          "Avviare la commessa prima di gestire il prelievo di componenti."
        );
        return;
      }

      // Controllo se ci sono questionari per questo pulsante.
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.clickPrelievi(item, arg_cod_pulsante);
        },
      };

      const res = await this.handleClickCheck(
        item,
        arg_cod_pulsante,
        stack_obj
      );

      if (res === "S") {
        return;
      }

      this.$emit("click_prelievi", item);
    },
    clickSubentro(item) {
      this.$emit("click_subentro", item);
    },
    clickRegistraPezzi(item) {
      if (item.view_disegno != null) {
        this.$emit("click_registra_pezzi", item);
      } else {
        // Se non ho visto il disegno, stampo una snackbar di errore.
        this.$refs.SnackbarQV.print(
          "orange",
          "Visionare nuova modifica di disegno prima di dichiarare."
        );
      }
    },
    clickRegistraScarti(item) {
      if (item.view_disegno != null) {
        this.$emit("click_registra_scarti", item);
      } else {
        // Se non ho visto il disegno, stampo una snackbar di errore.
        this.$refs.SnackbarQV.print(
          "orange",
          "Visionare nuova modifica di disegno prima di dichiarare."
        );
      }
    },
    clickRegistraPezziAlternativi(item) {
      if (item.view_disegno != null) {
        this.$emit("click_registra_cont_alternativi", item);
      } else {
        // Se non ho visto il disegno, stampo una snackbar di errore.
        this.snackbar = true;
        this.snackbar_background = "orange";
        this.snackbar_icon = "mdi-alert";
        this.snackbar_icon_color = "white";
        this.snackbar_text =
          "Visionare nuova modifica di disegno prima di dichiarare.";
        this.snackbar_text_color = "white";
      }
    },
    clickVisualizzaAllegatoControllo(item) {
      this.$emit("click_visualizza_allegto_controllo", item);
    },
    async clickVisualizzaDisegno(item, cod_pulsante) {
      console.log("entrato visualizzadisegno", cod_pulsante);
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.clickVisualizzaDisegno(item, cod_pulsante);
        },
      };

      const res = await this.handleClickCheck(item, cod_pulsante, stack_obj);

      if (res === "S") {
        return;
      }

      /* Controllo che ci siano disegni da
       * visualizzare (me ne accorgo perché se
       * non ci sono id_disegno == null). */
      if (item.id_disegno == null) {
        // Se non ci sono disegni lancio una snackber di errore
        this.$refs.SnackbarQV.print(
          "orange",
          "Non ci sono disegni da visualizzare."
        );
      } else {
        /* Se ci sono disegni emetto normalmente l'evento,
         * così il componente padre apre il dialog dei disegni. */
        this.$emit("click_visualizza_disegno", item);
      }
    },
    clickVisualizzaTabella(item) {
      this.workorder_sel = item;
      this.visualizza_dialog_tabella_custom = true;
    },
    getPulsantiCruscotto() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getpulsantiheader",
          token: localStorage.user_token,
          tipo_oggetto: "B",
          nome_modulo: "AVANZAMENTO",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_info_wo = [];

            res.data.forEach((e) => {
              if (e.tipo_oggetto == "D" && e.visible == 1) {
                this.items_info_wo.push(Object.assign({}, e));
              }
            });

            /* Verifico che il pulsante degli avvii multipli sia abilitato,
             * poi lo cancello perché per il cruscotto di avanzamento non avrebbe
             * senso di esistere sulle varie righe. (Il tasto di avvio multiplo
             * dei WO non deve stare nello spazio dei WO ma in una toolbar e deve
             * essere sempre solo un pulsate, per questo lo cancellerò con le
             * istruzioni qui sotto.) Faccio un ragionamento analogo anche per
             * il pulsante di lavoro squadra, che se è visibile deve far scattare
             * una chiamata particolare quando si stoppa il WO. */
            res.data.forEach((b) => {
              if (b.text === "Avvio Multiplo WO") {
                this.$emit("config_avvio_multiplo_wo", b.visible);
              } else if (b.text === "Lavoro Squadra") {
                this.gestione_team_enabled = b.visible;
              }
            });

            const arr_tmp = new Array();
            res.data.forEach((e) => {
              if (e.text != "Avvio Multiplo WO" && e.tipo_oggetto != "D") {
                arr_tmp.push(Object.assign({}, e));
              }
            });

            res.data = new Array();

            arr_tmp.forEach((e) => {
              res.data.push(Object.assign({}, e));
            });

            this.items_info_wo.sort((a, b) => a.ordine - b.ordine);

            /* Se presente, emetto l'id_header_query in modo che il componente
             * padre lo possa passare in prop ai componenti che ne hanno bisogno. */
            res.data.forEach((d) => {
              if (d.query != null) {
                this.$emit("id_header_query", d.id_header);
              }
            });

            /* Ho gestito i dati e la query, quindi ora
             * gestisco i pulsanti da renderizzare a video. */
            var tempPulsanti = [];
            tempPulsanti = res.data
              .sort((a, b) => a.ordine - b.ordine)
              .filter((e) => Number(e.visible) == 1 && e.tipo_oggetto == "B");

            var i3 = 0;
            this.rows = [];
            for (let i = 0; i < tempPulsanti.length; i += this.btnRowSize) {
              this.rows.push({ pulsanti: [] });
            }
            for (let i = 0; i < tempPulsanti.length; i++) {
              if (tempPulsanti[i].visible == 1) {
                this.rows[Math.floor(i3 / this.btnRowSize)].pulsanti.push(
                  Object.assign({}, tempPulsanti[i])
                );
                i3++;
              }
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    setCommessaTempi(commessa, start_stop, arg_nascondi, arg_emit, arg_dialog) {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessatempi",
          token: localStorage.getItem("user_token"),
          id_commessa: commessa.id_commessa,
          id_commessa_dettaglio: commessa.id_commessa_dettaglio,
          id_macchina: commessa.id_macchina,
          start: start_stop,
          id_causale: 55,
        },
      };

      const that = this;
      return new Promise((resolve) => {
        that.$store.dispatch("api", request).then(() => {
          that.overlay = false;
          if (start_stop == 0) {
            if (arg_emit === "on") {
              that.$emit("click_stop", commessa, arg_nascondi, arg_dialog);
            }
          } else {
            if (arg_emit === "on") {
              that.$emit("click_start");
            }
          }
          resolve();
        });
      });
    },
    async switchStartStop(
      elem,
      arg_nascondi,
      arg_emit,
      arg_dialog,
      arg_cod_pulsante
    ) {
      // Controllo se ci sono questionari per questo pulsante.
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.switchStartStop(
            elem,
            arg_nascondi,
            arg_emit,
            arg_dialog,
            arg_cod_pulsante
          );
        },
      };

      const res = await this.handleClickCheck(
        elem,
        arg_cod_pulsante,
        stack_obj
      );

      if (res === "S") {
        return;
      }

      /* Se arrivo qui è perché non ho bisogno di rispondere a nessun
       * questionario e posso eseguire la normale logica del metodo. */

      /* Faccio un controllo per verificare che in questo
       * momento la macchina sia effettivamente disponibile. */
      const chk_disponibilita = await this.chkDisponibilita(elem);
      if (chk_disponibilita != null && chk_disponibilita != "") {
        this.$refs.SnackbarQV.print(
          "orange",
          `La lavorazione del Work Order risulta impegnata da ${chk_disponibilita}.`
        );
        return;
      }

      /* Faccio scattare l'overlay di caricamento,
       * poi le varie chiamate lo sbloccheranno. */
      this.overlay = true;

      if (
        elem.ora_start == null ||
        (elem.ora_start != null && elem.ora_stop != null)
      ) {
        // Se l'ho visto, stabilisco che ora è
        let adesso = moment();
        let orario_attivazione =
          adesso.date() +
          "/" +
          ("0" + (adesso.month() + 1)).substr(-2) +
          "/" +
          adesso.year() +
          " " +
          ("0" + adesso.hour()).substr(-2) +
          ":" +
          ("0" + adesso.minutes()).substr(-2);

        // Aggiorno il work order
        elem.ora_start = orario_attivazione;
        elem.ora_stop = null;

        // Mando al backend l'aggiornamento
        await this.setCommessaTempi(
          elem,
          "1",
          arg_nascondi,
          arg_emit,
          arg_dialog
        );
      } else {
        // Se ho finito di lavorare, stabilisco che ora è
        let adesso = moment();
        let orario_attivazione =
          adesso.date() +
          "/" +
          ("0" + (adesso.month() + 1)).substr(-2) +
          "/" +
          adesso.year() +
          " " +
          ("0" + adesso.hour()).substr(-2) +
          ":" +
          ("0" + adesso.minutes()).substr(-2);

        // Aggiorno l'oggetto
        elem.ora_stop = orario_attivazione;

        /* Se la gestione del team è abilitata, faccio una chiamata
         * per segnare stop su tutti i membri del team attivi. */
        if (this.gestione_team_enabled == 1) {
          await this.fermaLavorazioneTeam(elem);
        }

        // Mando al backend l'aggiornamento
        await this.setCommessaTempi(
          elem,
          "0",
          arg_nascondi,
          arg_emit,
          arg_dialog
        );

        // Riporto i campi di start e stop a null
        elem.ora_start = null;
        elem.ora_stop = null;
      }
    },
  },
  mounted() {
    this.NETWORK = this.$store.state.Network;
    this.isAdmin = localStorage.getItem("id_profilo") == 1;
    // Preparo i listener.
    document
      .getElementById("listener_carrello_insit")
      .addEventListener("cambiata_macchina", this.cambiaMacchina);

    document
      .getElementById("listener_carrello_insit")
      .addEventListener("prelievo_registrato", this.aggiornaPrelievi);

    document
      .getElementById("listener_carrello_insit")
      .addEventListener("cambia_pulsanti", this.getPulsantiCruscotto);

    this.getDichiaraTurno();
    this.getPulsantiCruscotto();
  },
  beforeDestroy() {
    if (document.getElementById("listener_carrello_insit")) {
      document
        .getElementById("listener_carrello_insit")
        .removeEventListener("clicked_row", this.aggiungiWorkOrder);

      document
        .getElementById("listener_carrello_insit")
        .removeEventListener("prelievo_registrato", this.aggiornaPrelievi);

      document
        .getElementById("listener_carrello_insit")
        .removeEventListener("cambia_pulsanti", this.getPulsantiCruscotto);
    }
  },
};
</script>

<style scoped>
@keyframes controtazione {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes rotazione {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.controruota {
  animation: controtazione 1s infinite;
  animation-timing-function: linear;
}
.ruota {
  animation: rotazione 1s infinite;
  animation-timing-function: linear;
}
#listener_carrello_insit {
  font-size: 20px;
  text-align: center;
}
#listener_carrello_insit .button {
  height: 70px;
  width: 70px;
  min-width: 70px;
}
#listener_carrello_insit .evidenziato {
  background-color: pink;
}
#listener_carrello_insit .v-list-item {
  padding: 0;
}
#listener_carrello_insit .v-divider {
  border-color: #3f51b5;
  border-width: 2px;
}
#listener_carrello_insit .label {
  color: #3f51b5;
  margin-bottom: 7px;
}

@media screen and (max-width: 900px) {
  #listener_carrello_insit {
    font-size: 18px;
  }
  #listener_carrello_insit .button {
    height: 65px;
    width: 65px;
    min-width: 65px;
  }
}
@media screen and (max-width: 840px) {
  #listener_carrello_insit {
    font-size: 16px;
  }
  #listener_carrello_insit .button {
    height: 60px;
    width: 60px;
    min-width: 60px;
  }
}
</style>
